import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { L10nLocale, L10N_LOCALE } from 'angular-l10n';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BaseService } from 'src/app/core/services/base.service';
import { MessageBusService, PublicProfileMessage } from 'src/app/core/services/message-bus.service';
import { PublicProfileService } from 'src/app/core/services/public-profile.service';
import { PublicProfile } from 'src/app/shared/models/people/public-profile.model';
import { isPlatformBrowser } from '@angular/common';
import { PublicProfileVersion } from 'src/app/shared/models/systems/portal-phr.model';
import { LayoutService } from 'src/app/core/services/layout.service';


@Component({
  selector: 'app-public-profile-manager',
  templateUrl: './public-profile-manager.component.html',
  styleUrls: ['./public-profile-manager.component.css'],
  encapsulation: ViewEncapsulation.None  
})
export class PublicProfileManagerComponent implements OnInit, OnDestroy {
  private ngUnsubscribe = new Subject();
  private _formFinishLoading:boolean = false;

  idAreaSistema: number;
  nickname: string;
  accountName: string;
  language: string;
  publicProfile: PublicProfile;  
  hasHistory: boolean;
  isBrowser: boolean;

  constructor(
    private route : ActivatedRoute,
    private router: Router,
    private baseService: BaseService,
    private messageBusService: MessageBusService,
    private publicProfileService: PublicProfileService,
    @Inject(L10N_LOCALE) public locale: L10nLocale,
    private layoutService: LayoutService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);

  }
  
  ngOnInit(): void {


    console.log('ngOnInit started');

    this.language = this.locale.language;
    this.nickname = this.route.snapshot.params.nickname;
    this.idAreaSistema = this.route.snapshot.data.idAreaSistema;
    this.accountName = this.baseService.getCliniwebDirectoryCompanyName();

    this.hasHistory = true;

    // Check if user navigated to this profile when on version 1
    if (this.baseService.getPublicProfileVersion() == PublicProfileVersion.V1) {
      let url = this.publicProfileService.getPublicProfileUrl(this.nickname);
      
      if (location.search)
        url += location.search;

      //this.router.navigate([url]);

      if(this.isBrowser){
        window.location.href = url;
      }

      return;
    }

    // There are some cases in which the user navigate back to this page from login and header is not visible
    /*if (isPlatformBrowser(this.platformId) && !this.layoutService.isHeaderVisible()) {
      
      setTimeout(() => {
        this.messageBusService.showHeader();
        this.messageBusService.showAnonymousMenu();
      }, 500);
    }*/

    this.publicProfile = this.route.snapshot.data['publicProfile'];
    
    // Check if the profile is deleted or not approved
    if (this.publicProfile == null 
      || this.publicProfile.eliminado.toLocaleLowerCase() == "s" 
      || this.publicProfile.aprobado.toLocaleLowerCase() == "n") {
        this.router.navigate(["/not-found"]);
        return;
      }

    this._formFinishLoading && this.sendPublicProfile();

    this.messageBusService.onFormFinishLoading()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(idAreaSistema => {
        if(this.idAreaSistema === idAreaSistema){
          this._formFinishLoading = true;

          this.publicProfile && this.sendPublicProfile();
        }
      });   

    this.messageBusService.onLocaleChange()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(message => {
        this.language = message.language;

        this.getPublicProfile().subscribe(p => {
          this.publicProfile = p;

          this.sendPublicProfile();
        });
      }
    );

    this.messageBusService.publicProfilePage();
  }

  getPublicProfile() : Observable<PublicProfile> {
    return this.publicProfileService.getPublicProfile(
      this.nickname,
      this.language,
      this.accountName);     
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  sendPublicProfile(){
    let message = new PublicProfileMessage();
    message.publicProfile = this.publicProfile;

    this.messageBusService.sendPublicProfile(message);
  }

  onHeaderBackClick() {
    /*if (this.hasHistory)
      this.location.back();
    else*/
      this.router.navigate([""], {relativeTo:this.route});
  }

  getRouteAnimationData() {
    //let result = this.contexts.getContext('primary')?.route?.snapshot?.data?.['animation'];
    let animation = this.route.snapshot?.data?.animation;

    return animation ?? '';
  }
}
